/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import { isBlank } from '@ember/utils';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { Editor } from 'cio/services/editor';
import AlertsService from 'cio/services/alerts';
import { inject as service } from '@ember/service';
import pako from 'pako';
import { GistPayload } from 'cio/utils/in-app/gist';

interface InAppSignature {
  Args: {
    payload: string;
  };
  Element: HTMLDivElement;
}

enum Tab {
  Message = 'Message',
  Json = 'JSON',
}

export default class InApp extends Component<InAppSignature> {
  @service alerts!: AlertsService;

  tabs = [
    { value: Tab.Message, label: Tab.Message },
    { value: Tab.Json, label: Tab.Json },
  ];
  @tracked currentTab = Tab.Message;

  get isMessageTabSelected() {
    return this.currentTab === Tab.Message;
  }

  get gistPayload() {
    try {
      return JSON.parse(this.args.payload) as GistPayload;
    } catch {
      return {} as GistPayload;
    }
  }

  get isVisualEditorMessage() {
    return !isBlank(this.gistPayload?.properties?.gist?.encodedMessageHtml);
  }

  get previewPayload() {
    let gist = { ...this.gistPayload };
    let editor = this.isVisualEditorMessage ? Editor.VISUAL : Editor.JSON;

    if (this.isVisualEditorMessage) {
      gist.properties.gist.messageHtml = this.decodeMessageHTML(gist.properties.gist.encodedMessageHtml ?? '');
    }

    return {
      body_json: gist,
      editor,
      errors: {
        to: null,
        body_json: null,
      },
    };
  }

  private decodeMessageHTML(encodedMessageHtml: string) {
    try {
      let decodedData = Uint8Array.from(atob(encodedMessageHtml), (c) => c.charCodeAt(0));
      let decompressedData = pako.inflate(decodedData);
      let decoder = new TextDecoder('utf-8');
      return decoder.decode(decompressedData);
    } catch (error) {
      this.alerts.error('delivery.detail-error', "We weren't able to load the message content.");
    }

    return '';
  }
}
